// Quantity change
window.initCartQty = () => {
    document.querySelectorAll('.cart-qty').forEach((qtyEl) => {
        if (!qtyEl.classList.contains('init')) {
            qtyEl.classList.add('init');
            qtyEl.addEventListener('change', () => {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: qtyEl.dataset.lineItemKey,
                        quantity: qtyEl.value,
                    }),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        document.querySelectorAll('.cart-items-count').forEach((el) => {
                            el.textContent = data.item_count;
                        });

                        fetch(window.location.href)
                            .then((response) => response.text())
                            .then((data2) => {
                                const parser = new DOMParser();
                                const newDocument = parser.parseFromString(data2, 'text/html');

                                document.querySelector('#offcanvas-cart-inner')
                                    ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));
                                document.querySelector('#cart-page')
                                    ?.replaceWith(newDocument.querySelector('#cart-page'));

                                const desktopNew1 = newDocument.querySelector('#cart-badge-navbar-desktop');
                                const mobileNew1 = newDocument.querySelector('#cart-badge-navbar-mobile');
                                const desktopCurr1 = document.querySelector('#cart-badge-navbar-desktop');
                                const mobileCurr1 = document.querySelector('#cart-badge-navbar-mobile');
                                if (desktopNew1 && desktopCurr1) desktopCurr1.replaceWith(desktopNew1);
                                if (mobileNew1 && mobileCurr1) mobileCurr1.replaceWith(mobileNew1);

                                console.log('counter updated');

                                if (data.items.length === 0) {
                                    setTimeout(() => {
                                        const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'));
                                        offcanvas.hide();
                                    }, 500);
                                }

                                window.initCartQty();
                                window.initRemoveButtons();
                                window.initCartOffcanvasUpsells();
                            });
                    });
            });
        }
    });
};
window.initCartQty();
// Quantity Inputs
// window.onChangeCartQty = async (input) => {
//     const response = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//             id: input.dataset.lineItemKey,
//             quantity: input.value
//         })
//     })
//          const CartResponse = await fetch(window.location.href);
//     const text = await CartResponse.text();

//     const parser = new DOMParser();
//     const newDocument = parser.parseFromString(text, 'text/html');

//     document.querySelector('#offcanvas-cart-inner')
//         ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));
// }

// Remove Buttons
// window.onRemoveCartItem = async (btn) => {
//     const response = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//             id: btn.dataset.lineItemKey,
//             quantity: 0
//         })
//     })
//     // window.refreshCartContents(response)
//      const CartResponse = await fetch(window.location.href);
//     const text = await CartResponse.text();

//     const parser = new DOMParser();
//     const newDocument = parser.parseFromString(text, 'text/html');

//     document.querySelector('#offcanvas-cart-inner')
//         ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));
// }
// Remove Buttons
window.initRemoveButtons = () => {
    document.querySelectorAll('.offcanvas-cart-remove-btn').forEach((btn) => {
        if (!btn.classList.contains('init')) {
            btn.classList.add('init');

            btn.addEventListener('click', () => {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: btn.dataset.lineItemKey,
                        quantity: 0,
                    }),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        document.querySelectorAll('.cart-items-count').forEach((el2) => {
                            el2.textContent = data.item_count;
                        });

                        fetch(window.location.href)
                            .then((response) => response.text())
                            .then((data2) => {
                                const parser = new DOMParser();
                                const newDocument = parser.parseFromString(data2, 'text/html');

                                document.querySelector('#offcanvas-cart-inner')
                                    ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));
                                document.querySelector('#cart-page')
                                    ?.replaceWith(newDocument.querySelector('#cart-page'));
                                const desktopNew2 = newDocument.querySelector('#cart-badge-navbar-desktop');
                                const mobileNew2 = newDocument.querySelector('#cart-badge-navbar-mobile');
                                const desktopCurr2 = document.querySelector('#cart-badge-navbar-desktop');
                                const mobileCurr2 = document.querySelector('#cart-badge-navbar-mobile');
                                if (desktopNew2 && desktopCurr2) desktopCurr2.replaceWith(desktopNew2);
                                if (mobileNew2 && mobileCurr2) mobileCurr2.replaceWith(mobileNew2);

                                if (data.items.length === 0) {
                                    setTimeout(() => {
                                        const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'));
                                        offcanvas.hide();
                                    }, 500);
                                }
                                window.initCartQty();
                                window.initRemoveButtons();
                                window.initCartOffcanvasUpsells();
                            });
                    });
            });
        }
    });
};
window.initRemoveButtons();

// Summary sticky position on cart page
(() => {
    const cartSummary = document.querySelector('#cart-summary.sticky-top');
    if (cartSummary) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight;
        cartSummary.style.top = `${navbarHeight + 20}px`;
        cartSummary.style.zIndex = '1019';
    }
})();

// Cart upsells on offcanvas cart modal
window.initCartOffcanvasUpsells = async () => {
    const modal = document.querySelector('#offcanvas-cart');
    const {
        upsellsEnabled,
        upsellsTitle,
        upsellsDescription,
        upsellsCollectionHandle,
        textAddToCartShort,
    } = modal.dataset;

    if (upsellsEnabled === 'false') {
        return;
    }

    const productsResponse = await fetch(`/collections/${upsellsCollectionHandle}/products.json`);
    const productsData = await productsResponse.json();
    // console.log(productsData);

    const cartResponse = await fetch('/cart.json');
    const cartData = await cartResponse.json();
    // console.log(cartData);

    let products = [];

    products = productsData.products.filter(
        (product) => product.variants.some(
            (variant) => variant.available,
        ),
    );

    products = products.filter(
        (product) => cartData.items.some(
            (item) => item.product_title.includes(product.title),
        ) === false,
    );

    products = products.sort(() => 0.5 - Math.random());

    let carouselItems = '';

    products.forEach((product, index) => {
        const variantOptions = product.variants.map(
            (variant) => `
                <option 
                    value="${variant.id}"
                    ${!variant.available ? 'disabled' : ''}>
                    ${variant.title} - ${window.formatMoney(variant.price)}
                </option>`,
        );

        const isArtWork = !product.tags.includes('hide-order-check-form');
        const artWorkWrapper =`<div class="art-work__wrapper"></div>`
        // product-form-api.js reads form.dataset.variants (id + available) for artwork validation
        const variantsData = JSON.stringify(
            product.variants.map((variant) => ({ id: variant.id, available: variant.available })),
        );

        carouselItems += `
            ${isArtWork ? `<form data-variants='${variantsData}'` : '<div'} class="carousel-item ${index === 0 ? 'active' : ''} ${isArtWork ? 'carousel-item--artwork' : ''}">
                <div class="row mx-n2 align-items-center">
                    <div class="col-3 px-2">
                        <a href="/products/${product.handle}" class="">
                            <img 
                                class="img-fluid img-thumbnail"
                                src="${window.resizeImage(product.images[0].src, '240x240_crop_center')}"
                                alt="" 
                                width="240"
                                height="240">
                        </a>
                    </div>
                    <div class="col-6 px-2">
                        <h3 class="h6 text-truncate mb-2">
                            <a href="/products/${product.handle}" class="text-decoration-none">
                                ${product.title}
                            </a>
                        </h3>
                        <p class="price-final mb-0 ${product.variants.length > 1 ? 'd-none' : ''}">
                            ${window.formatMoney(product.variants[0].price)}
                        </p>
                        <select data-product-handle="${product.handle}" name="id" class="form-select form-select-sm ${product.variants.length === 1 ? 'd-none' : ''}" aria-label="Select variant">
                            ${variantOptions}
                        </select>
                    </div>
                    <div class="col-3 px-2 text-center">
                        <button
                            type=" ${isArtWork ? 'submit' : 'button'}"
                            data-text-add-to-cart="${textAddToCartShort}"
                            class="btn btn-atc btn-primary btn-sm text-uppercase visible ${isArtWork ? 'btn-atc--art-work' : ''}">
                            ${textAddToCartShort}
                        </button>
                    </div>
                </div>
                ${isArtWork ? artWorkWrapper : ''}
            ${isArtWork ? '</form>' : '</div>'}
        `;
    });

    const upsellsCarousel = `
        <div id="offcanvas-cart-upsells" class="px-0 mt-6 mb-4 ${products.length === 0 ? 'd-none' : ''}">
            <h4 class="offcanvas-cart-upsells-title bg-light py-3 px-4 h5 text-cursive text-center mb-4">
                ${upsellsTitle}
            </h4>
            <p class="text-muted small text-center mt-n2 mb-4 ${upsellsDescription.length ? '' : 'd-none'}">
                ${upsellsDescription}
            </p>
            <div 
                id="offcanvas-cart-upsells-carousel" 
                class="carousel slide carousel-dark" 
                data-bs-ride="carousel">
                <div class="carousel-inner">
                    ${carouselItems}
                </div>
                <div class="carousel-controls-wrapper d-flex justify-content-center align-items-center mt-4 ${products.length === 1 ? 'd-none' : ''}">
                    <button 
                        class="carousel-control-prev" 
                        type="button" 
                        data-bs-target="#offcanvas-cart-upsells-carousel" 
                        data-bs-slide="prev"
                        style="top: auto; width: 24px; height: 24px;">
                        <span 
                            class="carousel-control-prev-icon" 
                            aria-hidden="true" 
                            style="width: 1.25rem; height: 1.25rem;">
                        </span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button 
                        class="carousel-control-next" 
                        type="button" 
                        data-bs-target="#offcanvas-cart-upsells-carousel" 
                        data-bs-slide="next"
                        style="top: auto; width: 24px; height: 24px;">
                        <span 
                            class="carousel-control-next-icon" 
                            aria-hidden="true" 
                            style="width: 1.25rem; height: 1.25rem;">
                        </span>
                        <span class="visually-hidden">Next</span>
                    </button>
                    <span class="carousel-controls-counter small opacity-60">
                        1/${products.length}
                    </span>
                </div>
            </div>
        </div>
    `;

    await new Promise((r) => setTimeout(r, 300));

    document.querySelector('#offcanvas-cart-upsell-wrapper')
        ?.insertAdjacentHTML('afterbegin', upsellsCarousel);

    const carouselEl = document.querySelector('#offcanvas-cart-upsells-carousel');

    if (carouselEl) {
        carouselEl.addEventListener('slide.bs.carousel', (e) => {
            const artWorks = document.querySelectorAll('.carousel-item--artwork-rendered');
            artWorks.forEach((artWork) => {
                const artWorkWrapper = artWork.querySelector('.art-work__wrapper');
                const button = artWork.querySelector('.btn-atc');
    
                artWork.classList.remove('carousel-item--artwork-rendered')
                artWorkWrapper.innerHTML = '';
                button.disabled = false;
            });
            carouselEl.querySelector('.carousel-controls-counter').textContent = `${e.to + 1}/${products.length}`;
        });
    }

    document.querySelectorAll('#offcanvas-cart-upsells .btn-atc:not(.btn-atc--art-work)')
        .forEach((btn) => {
            btn.addEventListener('click', async () => {
                btn.style.height = `${btn.clientHeight}px`;
                btn.innerHTML = `
                    <div 
                        class="spinner-border spinner-border-sm" 
                        role="status"
                        style="width: 1rem; height: 1rem">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                `;

                async function fetchProductJson(productHandle) {
                    const url = `${window.location.origin}/products/${productHandle}?section_id=product-json`;

                    try {
                      const response = await fetch(url);

                      if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                      }

                      const text = await response.text();
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(text, 'text/html');
                      const jsonElement = doc.querySelector('#product-json');

                      if (jsonElement) {
                        const productJSON = JSON.parse(jsonElement.textContent);

                        return productJSON;
                      } else {
                        throw new Error('JSON element not found');
                      }
                    } catch (error) {
                      console.error('Error fetching product JSON:', error);
                      throw error;
                    }
                };

                const variantId = btn.closest('.carousel-item').querySelector('select[name="id"]').value;
                const productData = {
                    id: Number(variantId),
                    quantity: 1,
                };
                const productJSON = await fetchProductJson(btn.closest('.carousel-item').querySelector('select[name="id"]').dataset.productHandle);

                if (productJSON.metafields.image_back || productJSON.metafields.image_front) {
                    const properties = {};

                    if (productJSON.metafields.image_front) {
                        properties['select-front'] = productJSON.metafields.image_front;
                    };

                    if (productJSON.metafields.image_back) {
                        properties['select-back'] = productJSON.metafields.image_back;
                    };

                    productData.properties = properties;
                };

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [productData],
                    }),
                });
                fetch(window.location.href)
                    .then((response) => response.text())
                    .then((data2) => {
                        const parser = new DOMParser();
                        const newDocument = parser.parseFromString(data2, 'text/html');

                        document.querySelector('#offcanvas-cart-inner')
                            ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));

                        const desktopNew3 = newDocument.querySelector('#cart-badge-navbar-desktop');
                        const mobileNew3 = newDocument.querySelector('#cart-badge-navbar-mobile');
                        const desktopCurr3 = document.querySelector('#cart-badge-navbar-desktop');
                        const mobileCurr3 = document.querySelector('#cart-badge-navbar-mobile');
                        if (desktopNew3 && desktopCurr3) desktopCurr3.replaceWith(desktopNew3);
                        if (mobileNew3 && mobileCurr3) mobileCurr3.replaceWith(mobileNew3);

                        window.initCartQty();
                        window.initRemoveButtons();
                        window.initCartOffcanvasUpsells();
                    });
            });
        });

    async function initArtWorkFlow(e) {
        const currentItem = e.currentTarget;
        const addToCartButton = currentItem.querySelector('.btn-atc');

        addToCartButton.disabled = true;

        const productHandle = currentItem.querySelector('select[name="id"]').dataset.productHandle;
        const productData = await fetchProductTemplate(productHandle);

        if (currentItem.classList.contains('carousel-item--artwork-rendered')) {
            addToCartWithArtWork(currentItem);
        } else {
            renderArtWorkElements(productData, currentItem);
        }
    };

    async function fetchProductTemplate(productHandle) {
        const url = `${window.location.origin}/products/${productHandle}`;

        try {
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const text = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');

          return doc;
        } catch (error) {
          console.error(error);
          throw error;
        }
    };

    async function renderArtWorkElements(productData, currentItem) {
        const artWorkWrapper = currentItem.querySelector('.art-work__wrapper');
        const label = productData.querySelector('.product-form-input-order-no__label');
        const input = productData.querySelector('#product-form-input-order-no');
        const text = productData.querySelector('.product-form-input-order-no__text');
        const artWorkDetails = productData.querySelector('#artwork-details-card');
        const tempELement = document.createElement('div');
        const addToCartButton = currentItem.querySelector('.btn-atc');

        input?.classList.add('cart-upsell__artwork-input');

        // ponytail: some products lack one/all artwork fields — insertAdjacentElement throws on null, so skip missing ones
        [label, input, text, artWorkDetails]
            .filter(Boolean)
            .forEach((el) => tempELement.insertAdjacentElement('beforeend', el));

        artWorkWrapper.innerHTML = tempELement.innerHTML;
        window.initArtWorkLister();

        currentItem.classList.add('carousel-item--artwork-rendered');
        addToCartButton.disabled = false;
    };

    async function addToCartWithArtWork(currentItem) {
        await fetch('/cart/add.js', { method: 'POST', body: new FormData(currentItem) });
        const response = await fetch(window.location.href);
        const text = await response.text();
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(text, 'text/html');

        document.querySelector('#offcanvas-cart-inner')
            ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));

        const desktopNew4 = newDocument.querySelector('#cart-badge-navbar-desktop');
        const mobileNew4 = newDocument.querySelector('#cart-badge-navbar-mobile');
        const desktopCurr4 = document.querySelector('#cart-badge-navbar-desktop');
        const mobileCurr4 = document.querySelector('#cart-badge-navbar-mobile');
        if (desktopNew4 && desktopCurr4) desktopCurr4.replaceWith(desktopNew4);
        if (mobileNew4 && mobileCurr4) mobileCurr4.replaceWith(mobileNew4);

        window.initCartQty();
        window.initRemoveButtons();
        window.initCartOffcanvasUpsells();
    };

    const artWorkForms = document.querySelectorAll('.carousel-item--artwork');

    artWorkForms.forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            initArtWorkFlow(e);
        })
    });
};

document.querySelector('#offcanvas-cart')
    .addEventListener('show.bs.offcanvas', () => {
        if (!document.querySelector('#offcanvas-cart-upsells')) {
            window.initCartOffcanvasUpsells();
        }
    });

// Cart Note

customElements.component = "btn-apply-note";

class BtnApplyNote extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("click", async () => {
        this.innerHTML = `
            <div 
                class="spinner-border spinner-border-sm" 
                role="status"
                style="width: 1rem; height: 1rem">
                <span class="visually-hidden">Loading...</span>
            </div>
        `;
        const note = this.previousElementSibling.value;

        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                note,
            }),
        });
        const data = await response.json();
        this.innerHTML = '✓';

        setTimeout(() => {
            this.innerHTML = this.dataset.text;
        }, 2000);
    });
  }

  connectedCallback() {
    this.addEventListeners();
  }
}

if (!customElements.get(customElements.component)) {
  customElements.define(customElements.component, BtnApplyNote);
}

/* Free Product Upsell form */
window.onSumitFreeProductUpsell = async (form, event) => {
    event.preventDefault();

    const btn = form.querySelector('button[name="add"]');
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });

    btn.innerHTML = btn.dataset.textAdd;

    const response = await fetch(window.location.href);
    const text = await response.text();

    const parser = new DOMParser();
    const newDocument = parser.parseFromString(text, 'text/html');

    document.querySelector('#offcanvas-cart-inner')
        ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));

    const desktopNew5 = newDocument.querySelector('#cart-badge-navbar-desktop');
    const mobileNew5 = newDocument.querySelector('#cart-badge-navbar-mobile');
    const desktopCurr5 = document.querySelector('#cart-badge-navbar-desktop');
    const mobileCurr5 = document.querySelector('#cart-badge-navbar-mobile');
    if (desktopNew5 && desktopCurr5) desktopCurr5.replaceWith(desktopNew5);
    if (mobileNew5 && mobileCurr5) mobileCurr5.replaceWith(mobileNew5);

    window.initCartQty();
    window.initRemoveButtons();
    window.initCartOffcanvasUpsells();
};

// Route Protection
window.onChangeRouteProtection = async (checkbox) => {
    window.showLoading();
    if (checkbox.checked) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: Number(checkbox.dataset.variantId),
                    quantity: 1,
                }],
            }),
        });
    } else {
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updates: {
                    [checkbox.dataset.variantId]: 0,
                },
            }),
        });
    }

    const response = await fetch(window.location.href);
    const text = await response.text();

    const parser = new DOMParser();
    const newDocument = parser.parseFromString(text, 'text/html');

    document.querySelector('#offcanvas-cart-inner')
        ?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'));

    const event = new CustomEvent('cart-updated', {
        bubbles: true,
    });
    document.dispatchEvent(event);
    window.hideLoading();
};

window.showLoading = () => {
    document.body.classList.add('loading-active');
}

window.hideLoading = () => {
    document.body.classList.remove('loading-active');
}